export default __webpack_public_path__ + "static/media/1296.2dc48256.png";